"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = {
    functional: true,
    props: {
        field: {
            type: Object,
            required: true,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        showLinkTextWithChildrenPresent: {
            type: Boolean,
            default: false,
        },
    },
    // Need to assign `any` return type because Vue type definitions are inaccurate.
    // The Vue type definitions set `render` to a return type of VNode and that's it.
    // However, it is possible to return null | string | VNode[] | VNodeChildrenArrayContents.
    render: function (createElement, context) {
        var children = context.children, _a = context.props, field = _a.field, editable = _a.editable, showLinkTextWithChildrenPresent = _a.showLinkTextWithChildrenPresent;
        var dynamicField = field;
        if (!field || (!dynamicField.editableFirstPart && !dynamicField.value && !dynamicField.href)) {
            return null;
        }
        // EXPERIENCE EDITOR RENDERING
        if (editable && dynamicField.editableFirstPart) {
            var markup = dynamicField.editableFirstPart;
            // in an ideal world, we'd pre-render Vue children here and inject them between editableFirstPart and editableLastPart.
            // However, we cannot combine arbitrary unparsed HTML (innerHTML) based components with actual vDOM components (the children)
            // because the innerHTML is not parsed - it'd make a discontinuous vDOM.
            // So, we'll go for the next best compromise of rendering the link field and children separately
            // under a wrapping div. Should be "good enough" for most cases - and write your own helper if it isn't. Or bring xEditor out of 2006.
            markup += dynamicField.editableLastPart;
            // in functional components, context.data should be passed along to the
            // `createElement` function in order to retain attributes and events
            // https://vuejs.org/v2/guide/render-function.html#Passing-Attributes-and-Events-to-Child-Elements-Components
            var elementData = __assign(__assign({}, context.data), { class: 'sc-link-wrapper', domProps: { innerHTML: markup } });
            var xEditorElement = createElement('span', elementData);
            if (children) {
                var childElements = createElement('span', { class: 'sc-link-editable-children-wrapper' }, children);
                return createElement('span', { class: 'sc-link-editable-wrapper' }, [
                    xEditorElement,
                    childElements,
                ]);
            }
            return xEditorElement;
        }
        // handle link directly on field for forgetful devs
        var link = dynamicField.href ? field : dynamicField.value;
        if (!link) {
            return null;
        }
        var linkText = showLinkTextWithChildrenPresent || !children || children.length === 0 ? (link.text || link.href) : null;
        var finalChildren = children ? __spreadArrays([linkText], children) : linkText;
        // in functional components, context.data should be passed along to the
        // `createElement` function in order to retain attributes and events
        // https://vuejs.org/v2/guide/render-function.html#Passing-Attributes-and-Events-to-Child-Elements-Components
        var data = __assign(__assign({}, context.data), { class: link.class, attrs: __assign(__assign({}, context.data.attrs), { href: link.href, title: link.title, target: link.target }) });
        return createElement('a', data, finalChildren);
    },
};
